/*(c) Copyright 2015 Pivotal Software, Inc. All Rights Reserved.*/
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = exports.TableRow = exports.TableCell = exports.TableHeader = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _puiReactIconography = require('pui-react-iconography');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash.sortby');

var _lodash2 = _interopRequireDefault(_lodash);

var _puiReactHelpers = require('pui-react-helpers');

require('pui-css-tables');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = _react2.default.PropTypes;

var SORT_ORDER = {
  asc: 0,
  desc: 1,
  none: 2
};

var TableHeader = exports.TableHeader = function (_React$Component) {
  (0, _inherits3.default)(TableHeader, _React$Component);

  function TableHeader() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TableHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleActivate = function (event) {
      var _this$props = _this.props,
          sortable = _this$props.sortable,
          onClick = _this$props.onClick,
          onSortableTableHeaderClick = _this$props.onSortableTableHeaderClick;

      if (sortable) onSortableTableHeaderClick(event);
      if (onClick) onClick(event);
    }, _this.handleKeyDown = function (event) {
      if (event.key === 'Enter') {
        _this.handleActivate(event);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TableHeader, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          onSortableTableHeaderClick = _props.onSortableTableHeaderClick,
          sortable = _props.sortable,
          others = (0, _objectWithoutProperties3.default)(_props, ['onSortableTableHeaderClick', 'sortable']);

      var props = (0, _puiReactHelpers.mergeProps)(others, { className: { 'sortable': sortable } });

      var thProps = (0, _extends3.default)({}, props, { tabIndex: 0, disabled: !sortable });
      if (sortable) {
        return _react2.default.createElement('th', (0, _extends3.default)({}, thProps, { onClick: this.handleActivate, onKeyDown: this.handleKeyDown, role: 'button' }));
      } else {
        return _react2.default.createElement('th', thProps);
      }
    }
  }]);
  return TableHeader;
}(_react2.default.Component);

TableHeader.propTypes = {
  onClick: types.func,
  onSortableTableHeaderClick: types.func,
  sortable: types.bool
};
var TableCell = function TableCell(_ref2) {
  var rowDatum = _ref2.rowDatum,
      index = _ref2.index,
      props = (0, _objectWithoutProperties3.default)(_ref2, ['rowDatum', 'index']);
  return _react2.default.createElement('td', props);
};

exports.TableCell = TableCell;
TableCell.propTypes = {
  index: types.number,
  rowDatum: types.any
};

var TableRow = function TableRow(_ref3) {
  var index = _ref3.index,
      props = (0, _objectWithoutProperties3.default)(_ref3, ['index']);
  return _react2.default.createElement('tr', props);
};

exports.TableRow = TableRow;
TableRow.propTypes = {
  index: types.number
};

var Table = exports.Table = function (_React$Component2) {
  (0, _inherits3.default)(Table, _React$Component2);

  function Table(props, context) {
    (0, _classCallCheck3.default)(this, Table);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call(this, props, context));

    _initialiseProps.call(_this2);

    var columns = props.columns,
        defaultSort = props.defaultSort;


    var sortColumn = columns.find(function (_ref4) {
      var sortable = _ref4.sortable,
          attribute = _ref4.attribute;

      return defaultSort ? attribute === defaultSort : sortable;
    });
    _this2.state = { sortColumn: sortColumn, sortOrder: SORT_ORDER.asc };
    return _this2;
  }

  (0, _createClass3.default)(Table, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref5) {
      var columns = _ref5.columns,
          defaultSort = _ref5.defaultSort;

      if (columns) {
        var sortColumn = columns.find(function (_ref6) {
          var sortable = _ref6.sortable,
              attribute = _ref6.attribute;

          return defaultSort ? attribute === defaultSort : sortable;
        });
        this.setState({ sortColumn: sortColumn, sortOrder: SORT_ORDER.asc });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var sortColumn = this.state.sortColumn;
      var _props2 = this.props,
          columns = _props2.columns,
          CustomRow = _props2.CustomRow,
          data = _props2.data,
          defaultSort = _props2.defaultSort,
          props = (0, _objectWithoutProperties3.default)(_props2, ['columns', 'CustomRow', 'data', 'defaultSort']);

      props = (0, _puiReactHelpers.mergeProps)(props, { className: ['table', 'table-sortable', 'table-data'] });

      var rows = sortColumn ? this.sortedRows(data) : this.rows(data);

      return _react2.default.createElement(
        'table',
        props,
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            this.renderHeaders()
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          rows
        )
      );
    }
  }]);
  return Table;
}(_react2.default.Component);

Table.propTypes = {
  columns: types.array.isRequired,
  CustomRow: types.func,
  data: types.array.isRequired,
  defaultSort: types.string
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.updateSort = function (sortColumn, isSortColumn) {
    if (isSortColumn) {
      return _this3.setState({ sortOrder: ++_this3.state.sortOrder % (0, _keys2.default)(SORT_ORDER).length });
    }

    _this3.setState({ sortColumn: sortColumn, sortOrder: SORT_ORDER.asc });
  };

  this.sortedRows = function (data) {
    var _state = _this3.state,
        sortColumn = _state.sortColumn,
        sortOrder = _state.sortOrder;

    if (sortOrder === SORT_ORDER.none) return _this3.rows(data);
    var sortedData = (0, _lodash2.default)(data, function (datum) {
      var rankFunction = sortColumn.sortBy || function (i) {
        return i;
      };
      return rankFunction(datum[sortColumn.attribute]);
    });

    if (sortOrder === SORT_ORDER.desc) sortedData.reverse();

    return _this3.rows(sortedData);
  };

  this.rows = function (data) {
    var _props3 = _this3.props,
        columns = _props3.columns,
        CustomRow = _props3.CustomRow;


    return data.map(function (datum, rowKey) {
      var cells = columns.map(function (_ref7, key) {
        var attribute = _ref7.attribute,
            CustomCell = _ref7.CustomCell;

        var Cell = CustomCell || TableCell;
        return _react2.default.createElement(
          Cell,
          { key: key, index: rowKey, value: datum[attribute], rowDatum: datum },
          datum[attribute]
        );
      });

      var Row = CustomRow || TableRow;
      return _react2.default.createElement(
        Row,
        { key: rowKey, index: rowKey },
        cells
      );
    });
  };

  this.renderHeaders = function () {
    var _state2 = _this3.state,
        sortColumn = _state2.sortColumn,
        sortOrder = _state2.sortOrder;

    return _this3.props.columns.map(function (column, index) {
      var attribute = column.attribute,
          sortable = column.sortable,
          displayName = column.displayName,
          _column$headerProps = column.headerProps,
          headerProps = _column$headerProps === undefined ? {} : _column$headerProps;

      var isSortColumn = column === sortColumn;
      var className = void 0,
          icon = void 0;
      if (isSortColumn) {
        className = ['sorted-asc', 'sorted-desc', ''][sortOrder];
        icon = [_react2.default.createElement(_puiReactIconography.Icon, { src: 'arrow_drop_up' }), _react2.default.createElement(_puiReactIconography.Icon, { src: 'arrow_drop_down' }), null][sortOrder];
      }

      className = (0, _classnames2.default)(className, headerProps.className);

      headerProps = (0, _extends3.default)({}, headerProps, {
        className: className,
        sortable: sortable,
        key: index,
        onSortableTableHeaderClick: function onSortableTableHeaderClick() {
          return _this3.updateSort(column, isSortColumn);
        }
      });

      return _react2.default.createElement(
        TableHeader,
        headerProps,
        displayName || attribute,
        icon
      );
    });
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/pui-react-table/table.js
// module id = 804
// module chunks = 0